/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ExamRevisionLangBotexamlangid202,
  PutApiV1ExamRevisionLangBotexamlangid400,
  PutApiV1ExamRevisionLangBotexamlangid401,
  PutApiV1ExamRevisionLangBotexamlangid404,
  PutApiV1ExamRevisionLangBotexamlangid500,
  PutApiV1ExamRevisionLangBotexamlangidMutationRequest,
  PutApiV1ExamRevisionLangBotexamlangidMutationResponse,
  PutApiV1ExamRevisionLangBotexamlangidPathParams,
} from "../../types/examRevisionController/PutApiV1ExamRevisionLangBotexamlangid.ts";
import { updateBotExamLangViewModelSchema } from "../updateBotExamLangViewModelSchema.ts";

export const putApiV1ExamRevisionLangBotexamlangidPathParamsSchema = z.object({
  botExamLangId: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1ExamRevisionLangBotexamlangidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ExamRevisionLangBotexamlangid202Schema =
  z.any() as unknown as ToZod<PutApiV1ExamRevisionLangBotexamlangid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ExamRevisionLangBotexamlangid400Schema =
  z.any() as unknown as ToZod<PutApiV1ExamRevisionLangBotexamlangid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ExamRevisionLangBotexamlangid401Schema =
  z.any() as unknown as ToZod<PutApiV1ExamRevisionLangBotexamlangid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ExamRevisionLangBotexamlangid404Schema =
  z.any() as unknown as ToZod<PutApiV1ExamRevisionLangBotexamlangid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ExamRevisionLangBotexamlangid500Schema =
  z.any() as unknown as ToZod<PutApiV1ExamRevisionLangBotexamlangid500>;

export const putApiV1ExamRevisionLangBotexamlangidMutationRequestSchema =
  z.lazy(
    () => updateBotExamLangViewModelSchema,
  ) as unknown as ToZod<PutApiV1ExamRevisionLangBotexamlangidMutationRequest>;

export const putApiV1ExamRevisionLangBotexamlangidMutationResponseSchema =
  z.lazy(
    () => putApiV1ExamRevisionLangBotexamlangid202Schema,
  ) as unknown as ToZod<PutApiV1ExamRevisionLangBotexamlangidMutationResponse>;
